// test1052
(1052 && 0);
